import React, { useState } from "react";
import {useTranslation} from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PageHeader, { parentRoutes } from "../../../components/Header/PageHeader";
import { Form } from "../../../components/Form/Form"
import { faArrowProgress } from '@fortawesome/pro-light-svg-icons/faArrowProgress';
import {createEgressGateway} from '../../../actions/actionEgressProvider';
import EgressGatewayForm from "../EgressGatewayForm/EgressGatewayForm";

const parentRouteList = parentRoutes('/egress_providers')
const newRoutes = [
    ...parentRouteList.routes,
    {name: "generic.create",path:"/update_egress_provider",isActive: true},
];

const tabList = [
    { name: 'generic.create', key: 'form' },
]

export default function CreateEgressGateway(props) {
    const { t } = useTranslation('common');
    const [currentTab, setCurrentTab] = useState('form');
    const currentProvider = props.match.params.id

    const onSuccess = () => {
        props.history.push(`/update_egress_provider/${currentProvider}?tab=gateway`);
    }

    return (
        <div>
        <PageHeader location={props.location} routes={typeof newRoutes !== 'undefined' ? newRoutes : null} title={t('egress_provider.create-egress-gateway')} icon={<FontAwesomeIcon icon={faArrowProgress} />} />
        <Form 
            {...props}
            tabList={tabList}
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
            section="egress_provider"
            dispatchFunc={createEgressGateway}
            onSuccess={onSuccess}
            form={<EgressGatewayForm {...props} />}
        />
    </div>
    )
}
